import React from "react";

export default function ExpenseTotals({ expenses }) {
  return (
    <tr>
      <td className="alignLeft hideBorders">Expenses</td>
      <td className="hideBorders">{expenses.month1}</td>
      <td className="hideBorders">{expenses.month2}</td>
      <td className="hideBorders">{expenses.month3}</td>
      <td className="hideBorders">{expenses.month4}</td>
      <td className="hideBorders">{expenses.month5}</td>
      <td className="hideBorders">{expenses.month6}</td>
      <td className="hideBorders">{expenses.month7}</td>
      <td className="hideBorders">{expenses.month8}</td>
      <td className="hideBorders">{expenses.month9}</td>
      <td className="hideBorders">{expenses.month10}</td>
      <td className="hideBorders">{expenses.month11}</td>
      <td className="hideBorders">{expenses.month12}</td>
    </tr>
  );
}
